import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-growth',
  templateUrl: './icon-growth.component.html',
  styleUrls: ['./icon-growth.component.scss']
})
export class IconGrowthComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
